import { render, staticRenderFns } from "./SuperDocChatPopup.vue?vue&type=template&id=09f1dda7&scoped=true"
import script from "./SuperDocChatPopup.vue?vue&type=script&lang=js"
export * from "./SuperDocChatPopup.vue?vue&type=script&lang=js"
import style0 from "./SuperDocChatPopup.vue?vue&type=style&index=0&id=09f1dda7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f1dda7",
  null
  
)

export default component.exports